import React from 'react';
import { styled } from '@linaria/react';

import { isError } from '../../utils/validators';
import { ArrowDown, Chevron } from '../icon';

/**
 * @TODO reuse
 */
const withError = (props, error, ok) => {
  const { meta, validate } = props;

  return validate === 'submit' ? (isSubmitError(meta) ? error : ok) : isError(meta) ? error : ok;
};

const SelectField = styled.div`
  position: relative;
  background-color: var(--bb-field-background);
  border-radius: var(--bb-field-border-radius);
  z-index: 1;

  &:hover {
    box-shadow: var(--bb-field-box-shadow--hover);
    border-color: var(--bb-field-border-color--hover);
    background-color: var(--bb-field-background--hover);
  }

  &:focus,
  &:active {
    background-color: var(--bb-field-background--focus);
  }
`;

const SelectChevron = styled.div`
  position: absolute;
  width: 45px;
  height: 45px;
  right: 0;
  top: 50%;
  margin-top: -22.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  z-index: -1;
`;

const Select = styled.select`
  background-color: rgba(255, 255, 255, 0);
  background-image: none;
  border-width: var(--bb-field-border-width);
  border-style: var(--bb-field-border-style);
  border-color: ${({ meta }) =>
    isError(meta) ? 'var(--bb-error-color) !important' : 'var(--bb-field-border-color)'};
  border-radius: var(--bb-field-border-radius);
  box-shadow: var(--bb-field-box-shadow);
  color: var(--bb-field-color);
  padding-top: var(--bb-field-padding-top);
  padding-right: var(--bb-field-padding-right);
  padding-bottom: var(--bb-field-padding-bottom);
  padding-left: var(--bb-field-padding-left);
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  font-size: var(--bb-field-font-size);
  line-height: var(--bb-field-line-height);
  overflow: hidden;
  text-overflow: ellipsis;
  appearance: none;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: var(--bb-field-placeholder);
  }

  &:hover {
    cursor: pointer;
    box-shadow: var(--bb-field-box-shadow);
    border-color: var(--bb-field-border-color--hover);
  }

  &:focus,
  &:active {
    border-color: ${({ meta }) =>
      isError(meta) ? 'var(--bb-error-color) !important' : 'var(--bb-field-border-color--focus)'};
    box-shadow: ${props =>
      withError(
        props,
        'var(--bb-field-box-shadow--focus-error)',
        'var(--bb-field-box-shadow--focus)',
      )};
  }

  &:disabled {
    border-color: var(--bb-field-border-color--disabled);
    background-color: var(--bb-field-background--disabled);

    &:focus,
    &:active {
      box-shadow: var(--bb-field-box-shadow--disabled);
      border-color: var(--bb-field-border-color--disabled);
      background-color: var(--bb-field-background--disabled);
    }
  }
`;

export default ({ meta = {}, arrow = false, ...rest }) => (
  <SelectField>
    <Select
      {...rest}
      meta={meta}
      disabled={meta.submitting}
    />
    <SelectChevron>{arrow ? <ArrowDown /> : <Chevron />}</SelectChevron>
  </SelectField>
);
